// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'fontTertiary', 'fontTertiary Fallback'"},"className":"__className_7fb3c1","variable":"__variable_7fb3c1"};